'use client'

import { Icon } from '@vinted/web-ui'
import { ArrowRight16 } from '@vinted/monochrome-icons'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  ElectronicsLandingPageEvent,
  ElectronicsDiscoverSectionModel,
  landingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import DiscoverSectionCard from './DiscoverSectionCard'
import useElectronicsLpVersion from '../../hooks/useElectronicsLpVersion'

type Props = { content: ElectronicsDiscoverSectionModel }

const DiscoverSection = ({ content: { title, cards, linkText, linkUrl } }: Props) => {
  const { track } = useTracking()
  const lpVersion = useElectronicsLpVersion()

  const handleOnLinkClick = async () =>
    track(
      landingPageEvent({
        event:
          lpVersion === 'buy'
            ? ElectronicsLandingPageEvent.BuyDiscoverAllLinkClick
            : ElectronicsLandingPageEvent.SellDiscoverAllLinkClick,
        targetDetails: linkUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section data-testid="discover-section" className="electronics__discover-section">
      <div className="electronics__discover-section-container">
        <h2 className="electronics__discover-title">{title}</h2>
        <a
          className="electronics__discover-link"
          href={linkUrl}
          data-testid="electronics-discover-link"
          onClick={handleOnLinkClick}
        >
          <span>{linkText}</span>
          <span className="electronics__discover-link-icon">
            <Icon name={ArrowRight16} />
          </span>
        </a>

        <div className="electronics__discover-cards-container">
          {cards.map((card, index) => (
            <DiscoverSectionCard {...card} key={index} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default DiscoverSection
